// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2BvF1","title":"InfoRow_title___J2kI"};